import { AccountingFieldsAction, SET_ACCOUNTING_FIELDS } from '@Actions/accountingFields';

import { IAccountingField } from '@Shared/accounting_field';

interface IAccountingFieldsState {
  accountingFields: IAccountingField[];
}

export const defaultState: IAccountingFieldsState = {
  accountingFields: []
};

export function accountingFieldsReducer(state = defaultState, action: AccountingFieldsAction) {
  switch (action.type) {
    case SET_ACCOUNTING_FIELDS:
      return {
        ...state,
        accountingFields: action.payload
      };

    default:
      return state;
  }
}
